// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"415":"069e322a","7136":"8e179e86","7607":"95b0f000","8609":"f53f7549","9718":"3a2ac90b"}[chunkId] + ".chunk.css";
};